import { rejectFailedRequestOrEmptyData } from '../../lib/request/rejectFailedRequest/rejectFailedRequest';
import { AxiosProxy } from '../axiosProxy/axiosProxy';
export type FeatureFlagName =
  | 'product-in-products'
  | 'accepted-vuln-triage'
  | 'slaV1'
  | 'license-issues-affected-components'
  | 'oss-scan'
  | 'portal'
  | 'new-filter-processing-assets'
  | 'import-gh-labels'
  | 'role-based-access-control-v1'
  | 'new-vuln-alerts-revamp'
  | 'new-component-columns';

const getFeatureFlag = async ({
  name,
}: {
  name: FeatureFlagName;
}): Promise<{ isEnabled: boolean }> => {
  const response = await AxiosProxy.get({ url: `platform/feature-flags/${name}` });

  const validatedResponse = await rejectFailedRequestOrEmptyData<{ isEnabled: boolean }>(
    response,
  );
  return validatedResponse.data;
};

export const PlatformApi = {
  getFeatureFlag,
};
